window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = '300';
window.lazySizesConfig.loadMode = 1;

$(function() {
    if (document.getElementsByClassName('swiper-container').length > 0) {
        new Swiper('.swiper-container', swiperConfig.homepage);
    }

    if (document.getElementsByClassName('tag-countdown').length > 0) {
        countdownClock.init('.tag-countdown');
    }

    smoothScrollToElement('.view-deals-anchor', '[data-tariff-container][data-tariff-product-layout]');

    if (document.getElementsByClassName('product-page-swiper-container').length > 0) {
        new Swiper('.product-page-swiper-container', swiperConfig.productPage);
    }

    if (document.querySelector('[data-product-family-swiper]')) {
        new Swiper('div[data-product-family-swiper]', swiperConfig.productPageFamily);
    }

    setTileHeights('.tile-title', 5);
    setTileHeights('.tariff-wrapper', 5);
    setTileHeights('.tile');

    $(document).on('cdt.deals-loaded', function() {
        $('[data-toggle="tooltip"]').tooltip();
    });

    $('[data-scroll-top]').on('click', function() {
        $('html, body').animate({
            scrollTop: 0
        }, 700);
    });
});

function setTileHeights(tileTariffClass, plusHeight) {
    // Set Tariff Section to be the same in all boxes
    let maxHeight = 0;
    $(tileTariffClass).removeAttr('style');
    $(tileTariffClass).each(function() {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height() + plusHeight;
        }
    }).css('min-height', maxHeight);
}

$(window).resize(function() {
    if ($(window).width() < 768) {
        setTileHeights('.tile-height', 20);
    }
    setTileHeights('.tile-title', 5);
    toggleBackToTopTriggerVisibility('.back-to-top');
});

$(window).scroll(function() {
    toggleBackToTopTriggerVisibility('.back-to-top');
});

function toggleBackToTopTriggerVisibility(el) {
    let $yPos = $(window).scrollTop();
    let $width = $(window).width();

    if ($width >= 992) {
        if ($yPos >= 1000) {
            $(el).fadeIn();
        }
        if ($yPos < 1000) {
            $(el).fadeOut();
        }
    } else {
        $(el).hide();
    }
}

// Show more deals if javascript is enabled
$('.filter-state-paginating .more-deals-expander').show();

function smoothScrollToElement(triggerEl, targetEl) {
    $(triggerEl).on('click', function() {
        $(targetEl).scrollTo();
    });
}

$.fn.scrollTo = function() {
    return this.each(function() {
        $('html, body').animate({
            scrollTop: $(this).offset().top
        }, 500);
    });
};

let swiperConfig = {
    homepage: {
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        setWrapperSize: true,
        spaceBetween: 15,
        loop: false,
        keyboardControl: true,
        slidesPerView: 3.23,
        autoHeight: true,
        grabCursor: true,
        breakpoints: {
            1380: {
                slidesPerView: 3
            },
            1200: {
                slidesPerView: 2.8
            },
            1080: {
                slidesPerView: 2.4
            },
            992: {
                slidesPerView: 1.9
            },
            768: {
                slidesPerView: 1.5
            },
            560: {
                slidesPerView: 1.15
            }
        }
    },
    productPage: {
        pagination: '.swiper-pagination',
        paginationClickable: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        simulateTouch: false,
        setWrapperSize: true,
        spaceBetween: 0,
        keyboardControl: true,
        loop: true
    },
    productPageFamily: {
        slidesPerView: 5,
        simulateTouch: true,
        setWrapperSize: true,
        spaceBetween: 15,
        freeMode: true,
        keyboardControl: true,
        loop: false,
        breakpoints: {
            480: {
                slidesPerView: 1.8,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: 3.9,
                spaceBetween: 15,
            },
            1300: {
                slidesPerView: 4.5,
                spaceBetween: 15,
            },
        }
    }
};

$(function() {
    let cookieLaw = $("div[data-banner-name='eucookielaw']");

    if (document.cookie.indexOf('eucookie') === -1) {
        cookieLaw.slideDown();
        let exdate = new Date();
        let expiredays = 365 * 10;
        exdate.setDate(exdate.getDate() + expiredays);
        document.cookie = 'eucookie=eucookie;path=/' + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString());
    } else {
        cookieLaw.remove();
    }

    cookieLaw.find('.btn-default').click(function() {
        cookieLaw.slideUp();
    });
});

$('.tariff-container').on('click', '[data-read-more-link] a', function(e) {
    e.preventDefault();
    $(this).parent().parent().find('[data-read-more-target]').removeClass('hidden');
    $(this).parent().remove();
});

function setUpCoverageCheckerModal(event) {
    let $buyButton = $(event.currentTarget);
    let $modal = $($buyButton.attr('data-coverage-checker'));
    $modal.find('[data-continue-to-basket]').attr('href', $buyButton.attr('href'));
    $modal.modal();
}

$('[data-coverage-checker].add-to-basket-btn').on('click', function(event) {
    event.preventDefault();
    setUpCoverageCheckerModal(event);
});

$('.tile [data-coverage-checker]').on('click', function(event) {
    event.preventDefault();
    setUpCoverageCheckerModal(event);
});

let starRatingHtmlTarget = $('[data-reviews-co-uk-summary-stars]');
let numberOfReviewsTarget = $('[data-reviews-co-uk-summary-reviews]');

if (starRatingHtmlTarget.length && numberOfReviewsTarget.length) {
    starRatingHtmlTarget.html($('.reviews-score-header .reviews-rating > span').html());
    numberOfReviewsTarget.text($('.reviews-score-header .reviews-total > span').text().replace('-', ''));
}

$(document).ready(function() {
    $('[data-toggle="html-tooltip"]').tooltip({
        placement: 'top',
        html: 'true'
    });

    let whitelistedCollapseHashes = ['#search', '#customerService', '#talkToUs'];

    if (whitelistedCollapseHashes.indexOf(window.location.hash) != -1) {
        let $element = $(window.location.hash);

        if ($element.length) {
            $element.collapse('show');

            if (window.location.hash == '#search') {
                $('body').addClass('header-search-active');
            }
        }
    }
});
